import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.typed-array.sort.js";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { TokenMetadata } from '../modes.js';
import { LogLevel } from '../../../platform/log/common/log.js';
import { MultilineTokens2, SparseEncodedTokens } from '../model/tokensStore.js';
export var SemanticTokensProviderStyling = /*#__PURE__*/function () {
  function SemanticTokensProviderStyling(_legend, _themeService, _logService) {
    _classCallCheck(this, SemanticTokensProviderStyling);

    this._legend = _legend;
    this._themeService = _themeService;
    this._logService = _logService;
    this._hashTable = new HashTable();
  }

  _createClass(SemanticTokensProviderStyling, [{
    key: "getMetadata",
    value: function getMetadata(tokenTypeIndex, tokenModifierSet, languageId) {
      var entry = this._hashTable.get(tokenTypeIndex, tokenModifierSet, languageId.id);

      var metadata;

      if (entry) {
        metadata = entry.metadata;

        if (this._logService.getLevel() === LogLevel.Trace) {
          this._logService.trace("SemanticTokensProviderStyling [CACHED] ".concat(tokenTypeIndex, " / ").concat(tokenModifierSet, ": foreground ").concat(TokenMetadata.getForeground(metadata), ", fontStyle ").concat(TokenMetadata.getFontStyle(metadata).toString(2)));
        }
      } else {
        var tokenType = this._legend.tokenTypes[tokenTypeIndex];
        var tokenModifiers = [];

        if (tokenType) {
          var modifierSet = tokenModifierSet;

          for (var modifierIndex = 0; modifierSet > 0 && modifierIndex < this._legend.tokenModifiers.length; modifierIndex++) {
            if (modifierSet & 1) {
              tokenModifiers.push(this._legend.tokenModifiers[modifierIndex]);
            }

            modifierSet = modifierSet >> 1;
          }

          if (modifierSet > 0 && this._logService.getLevel() === LogLevel.Trace) {
            this._logService.trace("SemanticTokensProviderStyling: unknown token modifier index: ".concat(tokenModifierSet.toString(2), " for legend: ").concat(JSON.stringify(this._legend.tokenModifiers)));

            tokenModifiers.push('not-in-legend');
          }

          var tokenStyle = this._themeService.getColorTheme().getTokenStyleMetadata(tokenType, tokenModifiers, languageId.language);

          if (typeof tokenStyle === 'undefined') {
            metadata = 2147483647
            /* NO_STYLING */
            ;
          } else {
            metadata = 0;

            if (typeof tokenStyle.italic !== 'undefined') {
              var italicBit = (tokenStyle.italic ? 1
              /* Italic */
              : 0) << 11
              /* FONT_STYLE_OFFSET */
              ;
              metadata |= italicBit | 1
              /* SEMANTIC_USE_ITALIC */
              ;
            }

            if (typeof tokenStyle.bold !== 'undefined') {
              var boldBit = (tokenStyle.bold ? 2
              /* Bold */
              : 0) << 11
              /* FONT_STYLE_OFFSET */
              ;
              metadata |= boldBit | 2
              /* SEMANTIC_USE_BOLD */
              ;
            }

            if (typeof tokenStyle.underline !== 'undefined') {
              var underlineBit = (tokenStyle.underline ? 4
              /* Underline */
              : 0) << 11
              /* FONT_STYLE_OFFSET */
              ;
              metadata |= underlineBit | 4
              /* SEMANTIC_USE_UNDERLINE */
              ;
            }

            if (tokenStyle.foreground) {
              var foregroundBits = tokenStyle.foreground << 14
              /* FOREGROUND_OFFSET */
              ;
              metadata |= foregroundBits | 8
              /* SEMANTIC_USE_FOREGROUND */
              ;
            }

            if (metadata === 0) {
              // Nothing!
              metadata = 2147483647
              /* NO_STYLING */
              ;
            }
          }
        } else {
          if (this._logService.getLevel() === LogLevel.Trace) {
            this._logService.trace("SemanticTokensProviderStyling: unknown token type index: ".concat(tokenTypeIndex, " for legend: ").concat(JSON.stringify(this._legend.tokenTypes)));
          }

          metadata = 2147483647
          /* NO_STYLING */
          ;
          tokenType = 'not-in-legend';
        }

        this._hashTable.add(tokenTypeIndex, tokenModifierSet, languageId.id, metadata);

        if (this._logService.getLevel() === LogLevel.Trace) {
          this._logService.trace("SemanticTokensProviderStyling ".concat(tokenTypeIndex, " (").concat(tokenType, ") / ").concat(tokenModifierSet, " (").concat(tokenModifiers.join(' '), "): foreground ").concat(TokenMetadata.getForeground(metadata), ", fontStyle ").concat(TokenMetadata.getFontStyle(metadata).toString(2)));
        }
      }

      return metadata;
    }
  }]);

  return SemanticTokensProviderStyling;
}();
export function toMultilineTokens2(tokens, styling, languageId) {
  var srcData = tokens.data;
  var tokenCount = tokens.data.length / 5 | 0;
  var tokensPerArea = Math.max(Math.ceil(tokenCount / 1024
  /* DesiredMaxAreas */
  ), 400
  /* DesiredTokensPerArea */
  );
  var result = [];
  var tokenIndex = 0;
  var lastLineNumber = 1;
  var lastStartCharacter = 0;

  while (tokenIndex < tokenCount) {
    var tokenStartIndex = tokenIndex;
    var tokenEndIndex = Math.min(tokenStartIndex + tokensPerArea, tokenCount); // Keep tokens on the same line in the same area...

    if (tokenEndIndex < tokenCount) {
      var smallTokenEndIndex = tokenEndIndex;

      while (smallTokenEndIndex - 1 > tokenStartIndex && srcData[5 * smallTokenEndIndex] === 0) {
        smallTokenEndIndex--;
      }

      if (smallTokenEndIndex - 1 === tokenStartIndex) {
        // there are so many tokens on this line that our area would be empty, we must now go right
        var bigTokenEndIndex = tokenEndIndex;

        while (bigTokenEndIndex + 1 < tokenCount && srcData[5 * bigTokenEndIndex] === 0) {
          bigTokenEndIndex++;
        }

        tokenEndIndex = bigTokenEndIndex;
      } else {
        tokenEndIndex = smallTokenEndIndex;
      }
    }

    var destData = new Uint32Array((tokenEndIndex - tokenStartIndex) * 4);
    var destOffset = 0;
    var areaLine = 0;

    while (tokenIndex < tokenEndIndex) {
      var srcOffset = 5 * tokenIndex;
      var deltaLine = srcData[srcOffset];
      var deltaCharacter = srcData[srcOffset + 1];
      var lineNumber = lastLineNumber + deltaLine;
      var startCharacter = deltaLine === 0 ? lastStartCharacter + deltaCharacter : deltaCharacter;
      var length = srcData[srcOffset + 2];
      var tokenTypeIndex = srcData[srcOffset + 3];
      var tokenModifierSet = srcData[srcOffset + 4];
      var metadata = styling.getMetadata(tokenTypeIndex, tokenModifierSet, languageId);

      if (metadata !== 2147483647
      /* NO_STYLING */
      ) {
        if (areaLine === 0) {
          areaLine = lineNumber;
        }

        destData[destOffset] = lineNumber - areaLine;
        destData[destOffset + 1] = startCharacter;
        destData[destOffset + 2] = startCharacter + length;
        destData[destOffset + 3] = metadata;
        destOffset += 4;
      }

      lastLineNumber = lineNumber;
      lastStartCharacter = startCharacter;
      tokenIndex++;
    }

    if (destOffset !== destData.length) {
      destData = destData.subarray(0, destOffset);
    }

    var _tokens = new MultilineTokens2(areaLine, new SparseEncodedTokens(destData));

    result.push(_tokens);
  }

  return result;
}

var HashTableEntry = function HashTableEntry(tokenTypeIndex, tokenModifierSet, languageId, metadata) {
  _classCallCheck(this, HashTableEntry);

  this.tokenTypeIndex = tokenTypeIndex;
  this.tokenModifierSet = tokenModifierSet;
  this.languageId = languageId;
  this.metadata = metadata;
  this.next = null;
};

var HashTable = /*#__PURE__*/function () {
  function HashTable() {
    _classCallCheck(this, HashTable);

    this._elementsCount = 0;
    this._currentLengthIndex = 0;
    this._currentLength = HashTable._SIZES[this._currentLengthIndex];
    this._growCount = Math.round(this._currentLengthIndex + 1 < HashTable._SIZES.length ? 2 / 3 * this._currentLength : 0);
    this._elements = [];

    HashTable._nullOutEntries(this._elements, this._currentLength);
  }

  _createClass(HashTable, [{
    key: "_hash2",
    value: function _hash2(n1, n2) {
      return (n1 << 5) - n1 + n2 | 0; // n1 * 31 + n2, keep as int32
    }
  }, {
    key: "_hashFunc",
    value: function _hashFunc(tokenTypeIndex, tokenModifierSet, languageId) {
      return this._hash2(this._hash2(tokenTypeIndex, tokenModifierSet), languageId) % this._currentLength;
    }
  }, {
    key: "get",
    value: function get(tokenTypeIndex, tokenModifierSet, languageId) {
      var hash = this._hashFunc(tokenTypeIndex, tokenModifierSet, languageId);

      var p = this._elements[hash];

      while (p) {
        if (p.tokenTypeIndex === tokenTypeIndex && p.tokenModifierSet === tokenModifierSet && p.languageId === languageId) {
          return p;
        }

        p = p.next;
      }

      return null;
    }
  }, {
    key: "add",
    value: function add(tokenTypeIndex, tokenModifierSet, languageId, metadata) {
      this._elementsCount++;

      if (this._growCount !== 0 && this._elementsCount >= this._growCount) {
        // expand!
        var oldElements = this._elements;
        this._currentLengthIndex++;
        this._currentLength = HashTable._SIZES[this._currentLengthIndex];
        this._growCount = Math.round(this._currentLengthIndex + 1 < HashTable._SIZES.length ? 2 / 3 * this._currentLength : 0);
        this._elements = [];

        HashTable._nullOutEntries(this._elements, this._currentLength);

        var _iterator = _createForOfIteratorHelper(oldElements),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var first = _step.value;
            var p = first;

            while (p) {
              var oldNext = p.next;
              p.next = null;

              this._add(p);

              p = oldNext;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      this._add(new HashTableEntry(tokenTypeIndex, tokenModifierSet, languageId, metadata));
    }
  }, {
    key: "_add",
    value: function _add(element) {
      var hash = this._hashFunc(element.tokenTypeIndex, element.tokenModifierSet, element.languageId);

      element.next = this._elements[hash];
      this._elements[hash] = element;
    }
  }], [{
    key: "_nullOutEntries",
    value: function _nullOutEntries(entries, length) {
      for (var i = 0; i < length; i++) {
        entries[i] = null;
      }
    }
  }]);

  return HashTable;
}();

HashTable._SIZES = [3, 7, 13, 31, 61, 127, 251, 509, 1021, 2039, 4093, 8191, 16381, 32749, 65521, 131071, 262139, 524287, 1048573, 2097143];